module.exports = __webpack_public_path__ + "assets/fb0a5adeeea30d595dcf4954a492790f.mp3";